<template>
  <router-view/>
</template>
<script>
import {xray} from "./config/pluginInit";
import Vue from "vue";

import Vuetify from "vuetify";
// Translation provided by Vuetify (javascript)
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default {
  name: "App",
  components: {},
  vuetify: new Vuetify({
    lang: {
      locales: {es},
      current: "es",
    },
  }),
  mounted() {
    xray.mainIndex();
  },
};
</script>
<style lang="scss">
@import "assets/scss/style.scss";
@import "assets/scss/awesome-notifications/style.scss";
@import "assets/scss/v-tooltip/style.scss";
</style>
